import { TableDateCell, TableTextCell, TableTitleCell } from '../../../Table'
import { REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME } from '../RequestArchivedPipelinesModal.constants'

export function renderCell({ item, name, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.title:
      return <TableTitleCell {...restProps} value={value} />

    case REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.category:
      return <TableTextCell {...restProps} value={value?.value} />

    case REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.archived:
    case REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.created:
      return <TableDateCell {...restProps} value={value} />

    default:
      return null
  }
}
